import React, { useCallback } from 'react';
import { Close, Input, Icon, Typography } from '@agencypmg/alli';
import filterClients from './filterClients';

const { Title, Label } = Typography;

export default function ClientSelectorHeader({
    onClose,
    clients,
    setFilteredClients,
}) {
    const onChange = useCallback(
        e => {
            setFilteredClients(filterClients(clients, e.target.value));
        },
        [setFilteredClients, clients],
    );

    return (
        <div className="border-b border-gray-400">
            <div className="flex justify-end m-5">
                <Close onClick={onClose} tabIndex={-1} />
            </div>
            <div className="pb-4 ml-6">
                <Label className="text-gray-750 font-medium">Manage</Label>
                <Title level={3}>Select Client</Title>
            </div>
            <div className="ml-4 mr-4 mb-4 flex items-center">
                <Input placeholder="Search" onChange={onChange} />
                <Icon type="search" className="text-blue-gray-500 ml-2" />
            </div>
        </div>
    );
}
